"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShieldProtected = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ShieldProtected = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 22"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  stroke: "#13126C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m12.406 7.656-4.682 4.576-2.128-2.08M17 8.956c0 5.198-3.067 9.889-8 12.044-4.933-2.155-8-6.846-8-12.044v-5.96c5.733-2.662 10.933-2.662 16 0v5.96Z"
}));
exports.ShieldProtected = ShieldProtected;
ShieldProtected.displayName = "ShieldProtected";